import * as THREE from 'three';
import { Boss } from './Boss.js';

export class BossManager {
    constructor(scene, player, audioManager, world = null) {
        this.scene = scene;
        this.player = player;
        this.audioManager = audioManager;
        this.world = world; // For boss terrain collision
        this.bosses = [];
        this.currentBoss = null;
        this.bossesDefeated = 0;
        this.bossSequence = ['clarence', 'mikenolan', 'lez'];
        this.killsRequired = [20, 60, 120]; // Kills needed for each boss (reduced for faster progression)
        this.totalKills = 0;
        this.bossSpawned = [false, false, false];
    }
    
    spawnNextBoss() {
        if (this.bossesDefeated >= this.bossSequence.length) {
            // All bosses defeated!
            if (window.game) {
                window.game.showVictory();
            }
            return;
        }
        
        const bossType = this.bossSequence[this.bossesDefeated];
        const spawnPosition = new THREE.Vector3(20, 1, 20);
        
        this.currentBoss = new Boss(this.scene, spawnPosition, bossType, this.audioManager, this.world);
        this.bosses.push(this.currentBoss);
        
        // Show boss intro message
        if (window.game && window.game.hud) {
            window.game.hud.showBossIntro(this.currentBoss.name, this.bossesDefeated + 1);
        }
    }
    
    checkBossStatus() {
        if (this.currentBoss && this.currentBoss.isDead && !this.currentBoss.mushroomsDropped) {
            this.bossesDefeated++;
            
            // Switch back to calm music after defeating boss
            this.audioManager.switchToCalmMusic();
            
            // Resume normal sasquatch spawning
            if (window.game && window.game.enemyManager) {
                window.game.enemyManager.setBossActive(false);
            }
            
            // Drop many mushrooms when boss dies
            this.dropBossMushrooms(this.currentBoss.mesh.position);
            this.currentBoss.mushroomsDropped = true;
            
            // Respawn choomas after boss defeat
            if (window.game && window.game.choomaManager) {
                window.game.choomaManager.respawnChoomas();
            }
            
            // Check if ALL bosses defeated - TRIGGER VICTORY!
            if (this.bossesDefeated >= this.bossSequence.length) {
                if (window.game) {
                    // Special cutscene for Lez (final boss)
                    const bossPosition = this.currentBoss.mesh.position.clone();
                    if (this.currentBoss.type === 'lez') {
                        window.game.showLezVictoryCutscene(bossPosition);
                    } else {
                        window.game.showVictory();
                    }
                }
            }
            
            // Don't spawn next boss automatically - wait for kill count
            this.currentBoss = null;
        }
    }
    
    dropBossMushrooms(position) {
        // Drop 5-8 mushrooms in a circle around boss
        const numMushrooms = 5 + Math.floor(Math.random() * 4);
        
        for (let i = 0; i < numMushrooms; i++) {
            const angle = (i / numMushrooms) * Math.PI * 2;
            const radius = 3 + Math.random() * 2; // 3-5 units from boss
            const dropPos = {
                x: position.x + Math.cos(angle) * radius,
                y: position.y,
                z: position.z + Math.sin(angle) * radius
            };
            
            if (window.game && window.game.world) {
                window.game.world.spawnMushroom(dropPos);
            }
        }
    }
    
    addKill() {
        this.totalKills++;
        
        // Check if we should spawn a boss
        for (let i = 0; i < this.killsRequired.length; i++) {
            if (this.totalKills >= this.killsRequired[i] && !this.bossSpawned[i]) {
                this.bossSpawned[i] = true;
                this.spawnBoss(i);
                break;
            }
        }
    }
    
    spawnBoss(index) {
        const bossType = this.bossSequence[index];
        const spawnPosition = new THREE.Vector3(20, 1, 20);
        
        this.currentBoss = new Boss(this.scene, spawnPosition, bossType, this.audioManager, this.world);
        this.bosses.push(this.currentBoss);
        
        // Switch to scary boss music!
        this.audioManager.switchToBossMusic();
        
        // Stop sasquatch spawning and make them one-shottable
        if (window.game && window.game.enemyManager) {
            window.game.enemyManager.setBossActive(true);
        }
        
        // Show boss intro message
        if (window.game && window.game.hud) {
            window.game.hud.showBossIntro(this.currentBoss.name, index + 1);
        }
    }
    
    update(deltaTime) {
        if (this.currentBoss && !this.currentBoss.isDead) {
            // Use camera position (player's actual position) not mesh position (feet)
            this.currentBoss.update(deltaTime, this.player.camera.position);
        }
        
        this.checkBossStatus();
    }
    
    getNextBossKills() {
        // Return kills needed for next boss
        for (let i = 0; i < this.killsRequired.length; i++) {
            if (!this.bossSpawned[i]) {
                return this.killsRequired[i];
            }
        }
        return null; // All bosses spawned
    }
    
    getCurrentBoss() {
        return this.currentBoss;
    }
}
